import { GeneralInfo } from './general-info'

export function About() {
  return <GeneralInfo />
}
